import { render } from "./DeliveryInfo.vue?vue&type=template&id=40c44f48"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__